import { NoteSuggestionData } from "@/store/note/types";

export enum NoteSuggestionStatus {
  Pending = "PENDING",
  Accepted = "ACCEPTED",
  Rejected = "REJECTED",
  Cleared = "CLEARED",
  Unknown = "UNKNOWN",
}

export const getRenderableSuggestionData = ({
  suggestionData,
}: {
  suggestionData: NoteSuggestionData | null | undefined;
}): NoteSuggestionData | undefined => {
  if (!suggestionData) return undefined;

  // Legacy optimistic suggestion data can be persisted without a status field.
  const suggestionStatus = suggestionData.status ?? NoteSuggestionStatus.Pending;

  if (suggestionStatus !== NoteSuggestionStatus.Pending) return undefined;
  return suggestionData;
};

export function buildSuggestionStatus({
  status,
  suggestionData,
}: {
  status: NoteSuggestionStatus;
  suggestionData: NoteSuggestionData;
}): NoteSuggestionData {
  return {
    ...suggestionData,
    status,
  };
}
